// Vendor Libs
import React from 'react';

// Components
import FlexDashboard from '../core/flex-dashboard';
import NetworkScrollable from '../search-data/network-scrollable';

// Configs
import getDashboardConfig from '../../../config/flex-dashboard-config';
import FreewheelConfig from '../app/freewheel-config';
import AdInsertionConfig from '../app/ad-insertion-config';

const dashboardConfig = {
    layout: {
        type: 'row',
        children: [
            {
                type: 'tabset',
                width: 300,
                children: [
                    {
                        type: 'tab',
                        name: 'Networks',
                        component: NetworkScrollable,
                    },
                ],
            },
            {
                type: 'tabset',
                children: [
                    {
                        type: 'tab',
                        name: 'Freewheel Config',
                        component: FreewheelConfig,
                    },
                    {
                        type: 'tab',
                        name: 'Ad Insertion Config',
                        component: AdInsertionConfig,
                    },
                ],
            },
        ],
    },
};

const dashboardVfb = () => <FlexDashboard dashboardConfig={getDashboardConfig(dashboardConfig)} dashboardName="vfb" />;

export default dashboardVfb;
